var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHeadphones = function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 19.37l-.663-.383a1.974 1.974 0 01-.722-2.696l2.015-3.492a1.974 1.974 0 012.697-.722l.663.382",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.015 20.733v0a.997.997 0 01-.365-1.363l3.99-6.91a.998.998 0 011.362-.366v0a1.995 1.995 0 01.73 2.725l-2.992 5.183a1.995 1.995 0 01-2.725.73z",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35 19.37l.663-.383a1.974 1.974 0 00.722-2.696L7.72 12.799a1.975 1.975 0 00-2.697-.722l-.663.382",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.998 12.094v0a.997.997 0 011.362.365l3.99 6.91a.998.998 0 01-.365 1.363v0a1.995 1.995 0 01-2.725-.73L2.268 14.82a1.995 1.995 0 01.73-2.725h0z",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.008 12.094v-1.086A9.007 9.007 0 0012 2v0a9.008 9.008 0 00-9.008 9.008v1.086",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeadphones;